import { render, staticRenderFns } from "./bolt_general_tab.vue?vue&type=template&id=4d7d0476&scoped=true&"
import script from "./bolt_general_tab.vue?vue&type=script&lang=js&"
export * from "./bolt_general_tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7d0476",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d7d0476')) {
      api.createRecord('4d7d0476', component.options)
    } else {
      api.reload('4d7d0476', component.options)
    }
    module.hot.accept("./bolt_general_tab.vue?vue&type=template&id=4d7d0476&scoped=true&", function () {
      api.rerender('4d7d0476', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/bolt_dine/location/tabs/bolt_general_tab.vue"
export default component.exports